import React from 'react';

import { NotFoundErrorPage } from '../components/error-pages/notfound-error/NotFoundErrorPage';

export const NotFoundPage: React.FC = () => <NotFoundErrorPage />;
